<script setup lang="ts">
import { useNotificationStore } from '@/stores/notification'
import { storeToRefs } from 'pinia'

const notificationStore = useNotificationStore()
const { notifications } = storeToRefs(notificationStore)
</script>

<template>
  <div class="fixed top-4 right-4 z-[100] flex flex-col gap-2 max-w-sm w-full pointer-events-none">
    <TransitionGroup
      name="notification"
      tag="div"
      class="flex flex-col gap-2 pointer-events-auto"
    >
      <div
        v-for="n in notifications"
        :key="n.id"
        class="flex items-center p-4 rounded-lg shadow-lg border-l-4 transition-all duration-300"
        :class="{
          'bg-white border-green-500 text-gray-800': n.type === 'success',
          'bg-white border-red-500 text-gray-800': n.type === 'error',
          'bg-white border-blue-500 text-gray-800': n.type === 'info',
        }"
      >
        <div class="flex-shrink-0 mr-3">
          <svg v-if="n.type === 'success'" class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <svg v-else-if="n.type === 'error'" class="h-6 w-6 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <svg v-else class="h-6 w-6 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div class="flex-1 text-sm font-medium">
          {{ n.message }}
        </div>
        <button
          @click="notificationStore.remove(n.id)"
          class="ml-4 flex-shrink-0 text-gray-400 hover:text-gray-600 focus:outline-none transition-colors"
        >
          <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped>
.notification-enter-from {
  opacity: 0;
  transform: translateX(30px);
}
.notification-leave-to {
  opacity: 0;
  transform: scale(0.95);
}
.notification-move {
  transition: transform 0.4s ease;
}
</style>
